/**
 * Super Admin Pages Index
 */

export { SuperAdminDashboard } from './Dashboard';
export { SuperAdminCompanies } from './Companies';
export { SuperAdminUsers } from './Users';
export { CreateUser } from './CreateUser';
export { default as SuperAdminPermissions } from './Permissions';

// Placeholder pages (to be implemented)
export function SuperAdminStats() {
  return (
    <div className="card" style={{ padding: '48px', textAlign: 'center' }}>
      <h1 className="title" style={{ fontSize: '28px', marginBottom: '16px' }}>📈 Estadísticas del Sistema</h1>
      <p className="meta">Próximamente - En desarrollo</p>
    </div>
  );
}
